import init from './init'
import items from './store/items'
import settings from './store/settings'

export default {
  init,
  store: {
    items,
    settings
  }
}
